module.exports = __webpack_public_path__ + "img/app-store.a5466617.png";